import { ReactComponent as RTAIcon } from './RTA-icon.svg'
export default RTAIcon